import { memo } from 'react'
import { SxProps } from '@mui/material'
import { Box } from '@/components/Layout'
import { Button } from '@/components/Inputs'
import { useTranslations } from '@/core/translation'
import { useCurrencySelectorController } from './CurrencySelector.controller'
import { currencySelectorStyles as styles } from './CurrencySelector.style'
import { CurrencySelectorProps } from './CurrencySelector.types'
import CurrencyModal from './CurrencyModal'

function CurrencySelector({
  code,
  isRail = false,
  isRound = false,
  showLabel = true,
  onChange,
}: CurrencySelectorProps) {
  const t = useTranslations('sidebar')
  const { isOpen, current, openModal, closeModal } = useCurrencySelectorController(code)

  return (
    <>
      <Button
        fullWidth
        color="secondary"
        onClick={openModal}
        aria-haspopup="dialog"
        aria-label={t('currency.title')}
        title={showLabel ? undefined : t('currency.title')}
        sx={
          [styles.trigger, isRail && styles.triggerRail, isRound && styles.triggerRound] as SxProps
        }
        textProps={{ sx: styles.triggerText }}
        startIcon={
          <Box sx={[styles.flagSlot, isRail && styles.flagSlotRail] as SxProps}>
            <Box component={current.flag} sx={styles.flagIcon} />
          </Box>
        }>
        {showLabel ? current.code : ''}
      </Button>

      <CurrencyModal open={isOpen} code={code} onClose={closeModal} onConfirm={onChange} />
    </>
  )
}

export default memo(CurrencySelector)
